import { StyleSheet } from 'aphrodite/no-important';
import { spacers, palettes } from '@trainline/depot-web/css/themes/trainline';

export default StyleSheet.create({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 1 auto',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  spinner: {
    margin: `${spacers.dp_s32} auto`,
  },
  header: {
    width: '1036px',
    flex: '0 1 auto',
    margin: `${spacers.dp_s32} auto`,
    display: 'flex',
    flexDirection: 'column',
    gap: spacers.dp_s24,
  },
  customerContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
  },
  bookingsContent: {
    background: palettes.dp_app_backdrop_dark,
  },
});
